import type { CCPreset } from '~/types/presets';
import type { MidiCC } from '~/types/midi';
import { getYoTestSynthDefaultProfile } from '~/lib/profiles/yoTestSynthProfile';

/**
 * "OG" CC preset for YO! Monosynth
 *
 * This preserves the original default values from src/config/defaults/monosynth.json
 * before the Init preset adjustments were made.
 */

const ogMonosynthCCs: MidiCC[] = [
  { number: 7, value: 110, scramble: false, smooth: false, show: true, min: 80, max: 110 },
  { number: 16, value: 95, scramble: true, smooth: false, show: true, min: 0, max: 127 },
  { number: 17, value: 1, scramble: true, smooth: false, show: true, min: 0, max: 127 },
  { number: 18, value: 113, scramble: true, smooth: false, show: true, min: 0, max: 127 },
  { number: 19, value: 61, scramble: true, smooth: false, show: true, min: 0, max: 127 },
  { number: 20, value: 5, scramble: true, smooth: false, show: true, min: 0, max: 70 },
  { number: 21, value: 75, scramble: true, smooth: false, show: true, min: 20, max: 100 },
  { number: 70, value: 99, scramble: true, smooth: false, show: true, min: 0, max: 127 },
  { number: 71, value: 67, scramble: true, smooth: false, show: true, min: 0, max: 80 },
  { number: 72, value: 115, scramble: true, smooth: false, show: true, min: 10, max: 127 },
  { number: 73, value: 61, scramble: true, smooth: false, show: true, min: 3, max: 80 },
  { number: 74, value: 104, scramble: true, smooth: false, show: true, min: 50, max: 110 },
  { number: 75, value: 58, scramble: true, smooth: false, show: true, min: 10, max: 127 },
  { number: 76, value: 14, scramble: true, smooth: false, show: true, min: 0, max: 127 },
];

/**
 * "OG" Monosynth CC Preset
 */
export const OG_MONOSYNTH_PRESET: CCPreset = {
  id: 'og-mono',
  name: 'OG',
  deviceType: 'MonoSynth',
  cc: ogMonosynthCCs,
  profiles: [getYoTestSynthDefaultProfile()],
  activeProfileId: 'yo-test-synth-default',
  createdAt: new Date().toISOString(),
  updatedAt: new Date().toISOString(),
  userId: null, // System preset
  isPublic: true,
};

/**
 * Get the "OG" Monosynth CC preset
 * Returns a deep copy to avoid mutation
 */
export function getOGMonosynthPreset(): CCPreset {
  return {
    ...OG_MONOSYNTH_PRESET,
    cc: OG_MONOSYNTH_PRESET.cc.map(cc => ({ ...cc })),
    profiles: OG_MONOSYNTH_PRESET.profiles.map(profile => ({
      ...profile,
      ccConfig: profile.ccConfig.map(config => ({ ...config })),
    })),
  };
}
